// extracted by mini-css-extract-plugin
export default {"container":"QZ-z","heading":"RZ-z","links":"SZ-z","copy":"TZ-z","subCopy":"UZ-z","linksLeft":"VZ-z","linksCenter":"WZ-z","linksRight":"XZ-z","link":"YZ-z","onlyLink":"ZZ-z"};